import { Catalogue } from '../../models/catalogue'

export interface CatalogueState {
  catalogues: Catalogue[]
}

export const initialState: CatalogueState = {
  catalogues: []
}

export const catalogueStoreKey = 'catalogue'
